/**
 * Labstep
 *
 * @module grid/SmartTable/coldefs/entity/metadata
 * @desc Column Definition for entity metadata
 */

import type { ColDef } from 'ag-grid-community';
import type { ResourceItemData } from 'labstep-web/components/ResourceItem/Action/BulkCreate/Modal/type';
import { getMetadataDateColDef } from 'labstep-web/grid/BatchCreateResourceItems/coldefs/metadata/date';
import { getMetadataDatetimeColDef } from 'labstep-web/grid/BatchCreateResourceItems/coldefs/metadata/datetime';
import { getMetadataDefaultColDef } from 'labstep-web/grid/BatchCreateResourceItems/coldefs/metadata/default';
import { getMetadataNumericColDef } from 'labstep-web/grid/BatchCreateResourceItems/coldefs/metadata/numeric';
import { getMetadataOptionsColDef } from 'labstep-web/grid/BatchCreateResourceItems/coldefs/metadata/options';

import type { Metadata } from 'labstep-web/models/metadata';
import { MetadataType } from 'labstep-web/models/metadata/types';
import type { Resource } from 'labstep-web/models/resource.model';

export const getMetadataColDef = (
  metadata: Metadata,
  resource: Resource,
  data: ResourceItemData[],
  setData: React.Dispatch<React.SetStateAction<ResourceItemData[]>>,
  dateFormats: Record<string, string>,
): ColDef => {
  switch (metadata.type) {
    case MetadataType.numeric:
      return getMetadataNumericColDef(metadata, data, setData);
    case MetadataType.date:
      return getMetadataDateColDef(
        metadata,
        resource,
        data,
        setData,
        dateFormats,
      );
    case MetadataType.datetime:
      return getMetadataDatetimeColDef(
        metadata,
        resource,
        data,
        setData,
        dateFormats,
      );
    case MetadataType.options:
      return getMetadataOptionsColDef(metadata, data, setData);
    default:
      return getMetadataDefaultColDef(metadata, data, setData);
  }
};
